const listaDeUsuarios = (state) => {
    return state.items || [];
}

const loadingUsuario = (state) => {
    return state.buscando
}

const usuarioSelecionado = (state) => {
    return state.selecionado
}

const usuario = (state) => {
    return state.usuario
}

// const tarefas = (state) => {
//     return state.tarefas
// }

// const regionais = (state) => {
//     return state.regionais
// }

// const equipes = (state) => {
//     return state.equipes
// }

// const listaDeConfiguracoesUsuarios = (state) => {
//     return state.items;
// }

// const configuracao = (state) => {
//     return state.configuracao
// }

export {
    listaDeUsuarios,
    loadingUsuario,
    usuarioSelecionado,
    usuario,
    // tarefas,
    // regionais,
    // equipes,
    // listaDeConfiguracoesUsuarios,
    // configuracao,
}